(() => {
  if (window.__reeeCollectionNavigationInstalled) return;
  window.__reeeCollectionNavigationInstalled = true;

  const loading = new WeakSet();

  const loadMore = async (button) => {
    if (!button || loading.has(button) || !button.href) return;
    const page = button.closest('.collection-page') || document;
    const grid = page.querySelector('[data-collection-grid]');
    const status = page.querySelector('[data-load-more-status]');
    if (!grid) return;

    loading.add(button);
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading…';
    if (status) status.textContent = '';

    try {
      const response = await fetch(button.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Load more request failed');
      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = nextDocument.querySelector('[data-collection-grid]');
      if (!nextGrid) throw new Error('Next collection page is missing its product grid');

      nextGrid.querySelectorAll('.product-card').forEach((card) => grid.append(card));
      const nextButton = nextDocument.querySelector('[data-load-more]');
      if (nextButton) {
        button.href = nextButton.href;
        button.textContent = 'Load more designs';
      } else {
        button.remove();
      }
      if (status) status.textContent = 'More designs loaded.';
    } catch (error) {
      button.textContent = 'Load more designs';
      if (status) status.textContent = 'Couldn’t load more designs. Try again.';
    } finally {
      loading.delete(button);
      button.removeAttribute('aria-busy');
    }
  };

  window.addEventListener('click', (event) => {
    const button = event.target?.closest?.('a[data-load-more]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    loadMore(button);
  }, true);
})();